var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgWithOthersNotSelected = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 43,
    viewBox: "0 0 42 43",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.0478516,
    width: 42,
    height: 42,
    rx: 14.6667,
    fill: "#DDE2EB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2693 8.92486L30.0279 12.5531L33.6562 21.3118L30.0279 30.0705L21.2693 33.6987L12.5106 30.0705L8.88091 21.3132L12.5092 12.5545L21.2693 8.92486ZM21.2693 7.37988L11.4168 11.4608L7.33594 21.3132L11.4168 31.1656L21.2693 35.2465L31.1217 31.1656L35.2026 21.3132L31.1217 11.4608L21.2693 7.37988Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4334 12.3158L21.7 8.66035L30.9666 12.3158L34.7643 21.0479L30.9666 29.7799L21.7 33.4354L12.4334 29.7799L8.63572 21.0479L12.4334 12.3158Z",
    fill: "#DDE2EB",
    stroke: "white",
    strokeWidth: 3
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWithOthersNotSelected);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/withOthersNotSelected.ce6e3a4c100394be3190d695481f671d.svg";